// 挂单状态
export const HANG_ORDER_STAUTS = {
    INTRANSACTION: 1, // 已发起交易
    HANGING: 2, // 挂单中
};

// 订单拆分状态
export const ORDER_SPLIT_STATUS = {
    ALLOW_SPLIT: 1,
    NOTALOOW_SPLIT: 0,
};

// 交易状态
// export const TRANSACTION_STATUS = {
//     DONE: 1,

// }

// 普通订单状态
export enum ORDER_STATUS_ENUM {
    BUYER_REQUEST = "WaitingSellerConfirm",
    SELLER_CANCELED_DEAL = "SellerCancelsPurchase",
    WAITING_FOR_TRANSFER = "WaitingBuyerPay",
    BUYRER_CANCELD_DEAL = "BuyerNotPay",
    TIME_OVER = "BuyerPaymentExceedsTimeLimit",
    TRANSFERRED = "BuyerConfirmsOrderHasBeenPaid",
    SELLER_DID_NOT_RECEIVE = "SellerHasNotReceivedPayment",
    DISPUTING = "BuyerAppeals",
    CANCELED_BY_OFFICIAL = "AdminCancelsOrder",
    CONFIRMED_BY_OFFICIAL = "AdminCompletesOrder",
    DEAL = "SellerCompletesOrder",
    BUYER_NOT_APPEALS = "BuyerNotAppeals",
};

// 交易订单状态
export enum TRANSACTING_ORDER_STATUS {
    // STEP 1
    HANGING =  1,
    BUYER_REQUEST = "WaitingSellerConfirm",
    // STEP 2
    SELLER_CANCELED_DEAL = "SellerCancelsPurchase",
    // STEP 3
    WAITING_FOR_TRANSFER = "WaitingBuyerPay",
    BUYRER_CANCELD_DEAL = "BuyerNotPay",
    TIME_OVER = "BuyerPaymentExceedsTimeLimit",
    // STEP 4
    TRANSFERRED = "BuyerConfirmsOrderHasBeenPaid",
    SELLER_DID_NOT_RECEIVE = "SellerHasNotReceivedPayment",
    DISPUTING ="BuyerAppeals",
    CANCELED_BY_OFFICIAL =  "AdminCancelsOrder",
    CONFIRMED_BY_OFFICIAL = "AdminCompletesOrder",
    DEAL = "SellerCompletesOrder",
    BUYER_NOT_APPEALS = "BuyerNotAppeals",

    WAITING_FOR_CONFIRM_DEAL = "WAITING_FOR_CONFIRM_DEAL",
    CONFIRMED = "CONFIRMED",
    WAITING_TRANSFER = "WAITING_TRANSFER",
    CONFIRM_TRANSFER = "CONFIRM_TRANSFER",
};

// 业务订单步骤
type OrderStepType = {
    [x in TRANSACTING_ORDER_STATUS]?: number
}
export const STEP: OrderStepType = {
    [TRANSACTING_ORDER_STATUS.HANGING]: 0,
    [TRANSACTING_ORDER_STATUS.BUYER_REQUEST]: 0,

    [TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL]: 1,

    [TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER]: 2,
    [TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL]: 2,
    [TRANSACTING_ORDER_STATUS.TIME_OVER]: 2,

    [TRANSACTING_ORDER_STATUS.TRANSFERRED]: 3,
    [TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE]: 3,
    [TRANSACTING_ORDER_STATUS.DISPUTING]: 3,
    [TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL]: 3,
    [TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL]: 3,
    [TRANSACTING_ORDER_STATUS.DEAL]: 3,
    [TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS]: 3,
};

// 买家步骤
export const BUYER_STEP: OrderStepType = {
    [TRANSACTING_ORDER_STATUS.HANGING]: 0,

    [TRANSACTING_ORDER_STATUS.BUYER_REQUEST]: 1,
    [TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL]: 1,

    [TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER]: 2,
    [TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL]: 2,
    [TRANSACTING_ORDER_STATUS.TIME_OVER]: 2,

    [TRANSACTING_ORDER_STATUS.TRANSFERRED]: 3,
    [TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE]: 3,
    [TRANSACTING_ORDER_STATUS.DISPUTING]: 3,
    [TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL]: 3,
    [TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL]: 3,
    [TRANSACTING_ORDER_STATUS.DEAL]: 3,
    [TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS]: 3,
};

// 订单状态颜色
export const STATUS_TYPE:OrderStepType = {
    // 积极状态
    [TRANSACTING_ORDER_STATUS.HANGING]: 1,
    [TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL]: 1,
    [TRANSACTING_ORDER_STATUS.DEAL]: 1,

    // 消极状态
    [TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL]: 0,
    [TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL]: 0,
    [TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE]: 0,
    [TRANSACTING_ORDER_STATUS.DISPUTING]: 0,
    [TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL]: 0,
    [TRANSACTING_ORDER_STATUS.TIME_OVER]: 0,
    [TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS]: 0,

    // 普通状态
    [TRANSACTING_ORDER_STATUS.TRANSFERRED]: 2,
    [TRANSACTING_ORDER_STATUS.BUYER_REQUEST]: 2,
    [TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER]: 2,
};

// 交易订单类型
export enum TRANSACTING_ORDER_TYPE {
    CLASS = 'class',
    BUYER = 'buyer-content',
    SELLER = 'seller-content',
    STEP = 'step'
}

// 交易订单状态
export function transactingOrderStatus(
    val: TRANSACTING_ORDER_STATUS, 
    type: TRANSACTING_ORDER_TYPE = TRANSACTING_ORDER_TYPE.CLASS, 
    step: number = 0
) {
    if (type === TRANSACTING_ORDER_TYPE.SELLER) {
        if (val === TRANSACTING_ORDER_STATUS.HANGING) return '挂单中...'
        if (val === TRANSACTING_ORDER_STATUS.BUYER_REQUEST) return '买家发起交易'

        if (val === TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL) return '卖家取消交易'

        if (val === TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER) return '等待买家转账'
        if (val === TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL) return '买家取消交易'
        if (val === TRANSACTING_ORDER_STATUS.TIME_OVER) return '超时取消交易'

        if (val === TRANSACTING_ORDER_STATUS.TRANSFERRED) return '买家已转账'
        if (val === TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE) return '卖家未收到款'
        if (val === TRANSACTING_ORDER_STATUS.DISPUTING) return '争议订单'
        if (val === TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL) return '平台取消交易'
        if (val === TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL) return '平台确认交易'
        if (val === TRANSACTING_ORDER_STATUS.DEAL) return '交易完成'

        if (val === TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS) return '申诉期未申诉'

    }

    if (type === TRANSACTING_ORDER_TYPE.BUYER) {
        if (val === TRANSACTING_ORDER_STATUS.HANGING) return '挂单中...'

        if (val === TRANSACTING_ORDER_STATUS.BUYER_REQUEST) return '请等待卖家确认'
        if (val === TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL) return '卖家取消交易'

        if (val === TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER) return '请等待买家转账'
        if (val === TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL) return '买家取消交易'
        if (val === TRANSACTING_ORDER_STATUS.TIME_OVER) return '超时取消交易'

        if (val === TRANSACTING_ORDER_STATUS.TRANSFERRED) return '买家已转账'
        if (val === TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE) return '卖家未收到款'
        if (val === TRANSACTING_ORDER_STATUS.DISPUTING) return '争议订单'
        if (val === TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL) return '平台取消交易'
        if (val === TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL) return '平台确认交易'
        if (val === TRANSACTING_ORDER_STATUS.DEAL) return '交易完成'

        if (val === TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS) return '申诉期未申诉'

    }

    if (type === TRANSACTING_ORDER_TYPE.STEP) {
        if (step != 0) {
            const _step = STEP[val] || 0
            if (_step > step && step === 1) return '已确认'
            if (_step > step && step === 2) return '已转账'

        }
        if (val === TRANSACTING_ORDER_STATUS.BUYER_REQUEST) return '等待确认'
        if (val === TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL) return '交易取消'

        if (val === TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER) return '等待转账'
        if (val === TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL) return '取消交易'
        if (val === TRANSACTING_ORDER_STATUS.TIME_OVER) return '超时取消'

        if (val === TRANSACTING_ORDER_STATUS.TRANSFERRED) return '等待转币'
        if (val === TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE) return '卖家未收到款'
        if (val === TRANSACTING_ORDER_STATUS.DISPUTING) return '争议订单'
        if (val === TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL) return '平台取消交易'
        if (val === TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL) return '平台确认交易'
        if (val === TRANSACTING_ORDER_STATUS.DEAL) return '确认转币'

        if (val === TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS) return '申诉期未申诉'
    }


    if (step != 0) {
        const _step = STEP[val] || 0
        if (_step > step && step === 1) return 'confirmed'
        if (_step > step && step === 2) return 'tranferred'

    }
    if (val === TRANSACTING_ORDER_STATUS.HANGING) return 'hanging'
    if (val === TRANSACTING_ORDER_STATUS.BUYER_REQUEST) return 'buyer-request'

    if (val === TRANSACTING_ORDER_STATUS.WAITING_FOR_CONFIRM_DEAL) return 'waiting-for-confirm-deal'
    if (val === TRANSACTING_ORDER_STATUS.CONFIRMED) return 'confirmed'
    if (val === TRANSACTING_ORDER_STATUS.SELLER_CANCELED_DEAL) return 'seller-canceled-deal'

    if (val === TRANSACTING_ORDER_STATUS.WAITING_FOR_TRANSFER) return 'waiting-for-transfer'
    if (val === TRANSACTING_ORDER_STATUS.TRANSFERRED) return 'tranferred'
    if (val === TRANSACTING_ORDER_STATUS.BUYRER_CANCELD_DEAL) return 'buyer-canceled-deal'
    if (val === TRANSACTING_ORDER_STATUS.TIME_OVER) return 'time-over'

    if (val === TRANSACTING_ORDER_STATUS.WAITING_TRANSFER) return 'waiting-transfer'
    if (val === TRANSACTING_ORDER_STATUS.CONFIRM_TRANSFER) return 'confirm-transfer'
    if (val === TRANSACTING_ORDER_STATUS.SELLER_DID_NOT_RECEIVE) return 'seller-did-not-receive'
    if (val === TRANSACTING_ORDER_STATUS.DISPUTING) return 'disputing'
    if (val === TRANSACTING_ORDER_STATUS.CANCELED_BY_OFFICIAL) return 'canceled-by-official'
    if (val === TRANSACTING_ORDER_STATUS.CONFIRMED_BY_OFFICIAL) return 'confirmed-by-official'
    if (val === TRANSACTING_ORDER_STATUS.DEAL) return 'deal'

    if (val === TRANSACTING_ORDER_STATUS.BUYER_NOT_APPEALS) return 'buyer-not-appeals'
}